// fetchProfileMessages.js
'use strict';
import parseLinkHeader from 'parse-link-header';

import fetch from '../resource/customFetch.js';
import objectifyArrayById from '../resource/objectifyArrayById.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';

import getMeData from '../selector/getMeData.js';
import {
  ADD_MESSAGES,
  ADD_LIST_ITEMS,
  SET_LIST_ITEMS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch archive messages
 * @kind action
 * @param {string} {id} - user id.
 * @param {string} {listId} - list id
 * @param {number} {page} - page
 * @param {number} {limit} - limit
 * @return {Promise} Action promise.
 */
const fetchProfileMessages =
  ({ id, listId, page = 1, limit = 10 }) =>
  async (dispatch, getState) => {
    const state = getState();
    const token = getMeData(state, 'token');
    const lists = getMeData(state, 'profileLists');
    if (!token || !lists || !lists[listId]) return;

    const fetchOptions = {
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    const { pathname } = lists[listId];
    const selectPath = ['profile', 'messages', listId, page];
    const listSelectPath = ['profile', 'messages', listId, id];
    const url = getResourceUrl({ endpoint: `${pathname}/${id}` });
    url.searchParams.append('page', page);
    url.searchParams.append('limit', limit);

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      const totalCount = parseInt(response.headers.get('x-total-count'), 10);
      const links = parseLinkHeader(response.headers.get('Link'));
      const nextPage = links && links.next && parseInt(links.next.page, 10);
      const lastPage = links && links.next && parseInt(links.last.page, 10);

      const payload = await response.json();
      const messages = objectifyArrayById({
        array: payload,
        template: { isUnlocked: true },
      });
      const itemIds = Object.keys(messages);

      const listActionType = page === 1 ? SET_LIST_ITEMS : ADD_LIST_ITEMS;
      dispatch({ type: ADD_MESSAGES, payload: { messages } });
      dispatch({
        type: listActionType,
        payload: {
          selectPath: listSelectPath,
          itemIds,
          totalCount,
          nextPage,
          lastPage,
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default fetchProfileMessages;
